<template lang="pug">
div
  v-card.pt-1.mb-5.pb-5.repairedCard(v-for= "(d, index) in repaired" :key="index")
    v-row
      v-col(cols="9")
        v-card-text.py-1(style="font-size: 12px;") Asignado: {{ formatDate(d.date_assigned) }}
        v-card-text.pt-0(style="font-size: 12px;") Terminado: {{ formatDate(d.date_finished) }}
        v-card-title.pb-5.pt-0(style="color: #462DFA") {{ d.service_name }}
        v-card-subtitle.py-1(style="color: #7B90DA; font-size: 16px;") {{d.vehicle_brand}} - {{d.vehicle_model}} - {{d.vehicle_patent}}
        v-card-text.pb-0(style="color: #7B90DA; font-size: 16px;")
          | Asociado a OT N°: {{ d.work_order }}
      v-col.d-flex.align-center(cols="3")
        v-btn.chevronButton(depressed width="40px" height="40px" color="#462DFA" @click="$router.push({ name: 'Detalle Reparaciones', params: {otID: d.work_order }})")
          v-icon(style="color: #fff;" dense) mdi-chevron-right
  v-pagination.mt-4.mb-4(v-model="page" :length="pageCount" circle color="primary" elevation=0)
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    data: Array
  },
  data () {
    return {
      page: 1,
      rowCount: 0,
      repaired: []
    }
  },
  methods: {
    ...mapActions('ot', ['listJobsRepaired', 'listJobsOrderRepaired']),
    fetchData () {
      this.listJobsOrderRepaired({ params: { page: this.page, is_job_list: true } }).then(
        response => {
          this.rowCount = response.data.count
          this.repaired = response.data.results
        }
      )
    },
    formatDate (date) {
      return new Intl.DateTimeFormat('cl-ES', { dateStyle: 'short', timeStyle: 'short', hour12: true }).format(new Date(date))
    }
  },
  computed: {
    pageCount () {
      return Math.ceil(this.rowCount / 10)
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    page () {
      this.fetchData()
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card__title {
  font-weight: 600 !important;
}
  a {
    color: #A3A2A1 !important;
  }
.repairedCard {
  border-left: 16px solid #462DFA;
}
.chevronButton {
  min-width: 40px !important;
  margin-left: 5px;
  margin-top: 12px;
}
</style>
